import { render, staticRenderFns } from "./AdminApi.vue?vue&type=template&id=6c6b595b&scoped=true"
import script from "./AdminApi.vue?vue&type=script&lang=ts"
export * from "./AdminApi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b595b",
  null
  
)

export default component.exports